const SHARED_PREFIX = "softcar.gettingStarted.bookingSiteShared:";
const COLLAPSED_PREFIX = "softcar.gettingStarted.collapsed:";

const readFlag = (prefix, userId) => {
    if (!userId) {
        return false;
    }

    try {
        return localStorage.getItem(`${prefix}${userId}`) === "true";
    } catch (_error) {
        return false;
    }
};

const writeFlag = (prefix, userId, value) => {
    if (!userId) {
        return;
    }

    try {
        localStorage.setItem(`${prefix}${userId}`, String(value));
    } catch (_error) {
        // Ignore quota / private-mode failures
    }
};

export const isBookingSiteShared = (userId) => readFlag(SHARED_PREFIX, userId);

export const markBookingSiteShared = (userId) => writeFlag(SHARED_PREFIX, userId, true);

/** Whether the user has dismissed the checklist, so "Hide" survives a reload. */
export const isGettingStartedCollapsed = (userId) => readFlag(COLLAPSED_PREFIX, userId);

export const setGettingStartedCollapsed = (userId, collapsed) => writeFlag(COLLAPSED_PREFIX, userId, collapsed);
